import { Route, RouteConfig } from 'vue-router';
import { WmsPageComposer } from '../components/page-composer/page-composer';
import { router } from './router';

export const REDIRECT_ROUTES: RouteConfig[] = [
	{
		path: '/page/hypoteka-s-garanci',
		name: 'hypoteka-s-garanci',
		alias: '/hypoteka-s-garanci',
		meta: { reRedirect: '/page/financovani' },
		props: { pageUrl: 'hypoteka-s-garanci' },
		component: WmsPageComposer
	}
];

export function reGuard(to: Route, _from: Route, next: Function): boolean {
	if (to.meta.reRedirect) {
		if (to.meta.reRedirect !== to.fullPath) {
			next({ path: to.meta.reRedirect, replace: true });
			return true;
		}
	}

	return false;
}
